export const newPoster = [
  {
    path: '/merchantMarketing/poster/index',
    name: 'posterIndexNew',
    component: () => import('views/merchantMarketing/newPoster/index.vue'),
    meta: {
      title: '海报中心'
    }
  },
  {
    path: '/merchantMarketing/newPoster/feedback',
    name: 'feedbackPoster',
    component: () => import('views/merchantMarketing/newPoster/feedback/index.vue'),
    meta: {
      title: '您的建议'
    }
  },
  {
    path: '/merchantMarketing/newPoster/posterVideo',
    name: 'posterVideo',
    component: () => import('views/merchantMarketing/newPoster/posterVideo/index.vue'),
    meta: {
      title: '玩转海报'
    }
  },
  {
    path: '/merchantMarketing/newPoster/makePoster',
    name: 'newMakePoster',
    component: () => import('views/merchantMarketing/newPoster/makePoster/index.vue'),
    meta: {
      title: '海报制作'
    }
  },
  {
    path: '/merchantMarketing/newPoster/myPoster',
    name: 'myPosterNew',
    component: () => import('views/merchantMarketing/newPoster/myPoster/index.vue'),
    meta: {
      title: '我的海报',
      keepAlive: true
    }
  },
  {
    path: '/merchantMarketing/newPoster/posterDetail',
    name: 'newPosterView',
    component: () => import('views/merchantMarketing/newPoster/posterDetail/index.vue'),
    meta: {
      title: '分享海报'
    }
  }
]

export const poster = [
  {
    path: '/merchantMarketing/poster/makePoster',
    name: 'makePoster',
    component: () => import('views/merchantMarketing/poster/makePoster.vue'),
    meta: {
      title: '海报制作'
    }
  },
  {
    path: '/merchantMarketing/oldPoster/index',
    name: 'posterIndex',
    component: () => import('views/merchantMarketing/poster/index.vue'),
    meta: {
      title: '拉客海报'
    }
  },
  {
    path: '/merchantMarketing/poster/myPosterList',
    name: 'myPosterList',
    component: () => import('views/merchantMarketing/poster/myPosterList.vue'),
    meta: {
      title: '我的海报',
      keepAlive: true
    }
  },
  {
    path: '/merchantMarketing/poster/workerPosterList',
    name: 'workerPosterList',
    component: () => import('views/merchantMarketing/poster/workerPosterList.vue'),
    meta: {
      title: '营销海报',
      keepAlive: true
    }
  },
  {
    path: '/merchantMarketing/poster/myPosterMemberList',
    name: 'myPosterMemberList',
    component: () => import('views/merchantMarketing/poster/myPosterMemberList.vue'),
    meta: {
      title: '会员充值海报'
    }
  },
  {
    path: '/merchantMarketing/poster/posterView',
    name: 'posterView',
    component: () => import('views/merchantMarketing/poster/posterView.vue'),
    meta: {
      title: '海报预览'
    }
  },
  {
    path: '/merchantMarketing/poster/buyPoster',
    name: 'buyPoster',
    component: () => import('views/merchantMarketing/poster/buyPoster.vue'),
    meta: {
      title: '海报详情'
    }
  }
]
